import { Provider } from '@angular/core';
import { ProjectEventBus } from '@web-portal/domains/shared/event-bus';

export function provideProjectDomain(): Provider[] {
  return [ProjectEventBus];
}
